<!-- 脸到采集状态 -->
<template>
  <el-form-item :label="label">
    <yx-basic-selector v-bind="config" v-model="ldStatus" type="ldStatus" clearable />
  </el-form-item>
</template>

<script>
import { inject } from 'vue';

export default {
  kind: 'yq-面部信息状态选择',
  props: {
    // 初始值.
    value: {
      type: [Array, String, Number],
      default: '',
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    label: {
      type: String,
      default: '面部信息状态：',
    },
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const ldStatus = useQuery('ldStatus', props.value);

    return {
      ldStatus,
    };
  },
};
</script>
